import React, { useState } from "react";
import { ListGroup, Button, Spinner } from "react-bootstrap";
import { getFiles, removeFolder } from "../../context/fetch/fetchAssets";
import { useAssetsValue } from "../../context/reducers/assetsContext";
import { MdModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import RemoveModal from "./RemoveModal";

const FolderList = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [state, dispatch] = useAssetsValue();
  const navigate = useNavigate();

  const { name, id, setIndex, setFolderId, showInModal } = props;
  const handleOnFolderClick = () => {
    const folderId = id === state.folder.activeFolderId ? null : id;
    getFiles(folderId, dispatch, navigate, setShowSpinner, showInModal);
  };

  const handleOnEditClick = (e) => {
    e.stopPropagation();
    setIndex(2);
    setFolderId(id);
  };

  const handleOnRemoveClick = () => {
    const folder = state.folder;
    removeFolder(id, dispatch, navigate, folder);
  };

  const getFileNames = () => {
    let files = state.folder.file.list;

    if (props.callLocation) {
      const ext = props.callLocation.split("-").splice(-2)[0];
      files = files.filter((item) => item.ext.split("/")[0] === ext);
    }

    return files.reduce((array, item) => {
      if (item.folderId === id) {
        array.push(
          <ListGroup.Item key={item.id}>
            <div className={"list-group-link image-name"}>{item.fileName}</div>
          </ListGroup.Item>
        );
      }
      return array;
    }, []);
  };

  return (
    <ListGroup variant="flush" className={"my-3"}>
      <ListGroup.Item className={"parent-list-group-item"}>
        <span
          onClick={handleOnFolderClick}
          className={
            id === state.folder.activeFolderId
              ? "list-group-link parent-list-group-link active"
              : "list-group-link parent-list-group-link"
          }
        >
          {name}
          <span className="control-btns">
            <span>
              {showSpinner && state.folder.file.isAssetsLoading && (
                <Spinner animation="grow" variant="success" />
              )}
            </span>
            <Button
              variant="outline-info"
              size="sm"
              onClick={(e) => handleOnEditClick(e)}
              className={`mx-2 ${showInModal ? "hidden" : ""}`}
            >
              <MdModeEdit />
            </Button>
            <span
              className={`${showInModal ? "hidden" : ""}`}
              onClick={(e) => e.stopPropagation()}
            >
              <RemoveModal handleOnRemoveClick={handleOnRemoveClick} />
            </span>
          </span>
        </span>
        <ListGroup
          variant="flush"
          className={
            id === state.folder.activeFolderId ? "d-block mt-3 pl-3" : "d-none"
          }
        >
          {getFileNames()}
        </ListGroup>
      </ListGroup.Item>
    </ListGroup>
  );
};

export default FolderList;
